var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"header"},[_vm._t("left"),_c('span',{staticClass:"header_title"},[_c('span',{staticClass:"header_title_text ellipsis"},[_vm._v(_vm._s(_vm.title))])]),_vm._t("right")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }